import Vue from "vue"
import * as XLSX from "xlsx"

/**
 * getVal => 获取本地存储
 * 
 * @param {String} key 
 * @returns 
 */
Vue.prototype.$getVal = function (key) {
    return localStorage.getItem(key)
}

/**
 * setVal => 设置本地存储
 * 
 * @param {String} key 
 * @param {String} val 
 */
Vue.prototype.$setVal = function (key, val) {
    localStorage.setItem(key, val)
}

/**
 * romVal => 清除本地存储
 * 
 * @param {String} key 
 */
Vue.prototype.$romVal = function (key) {
    localStorage.removeItem(key)
}

/**
 * oneRouter => 路由防抖(禁止重复点击)
 * 
 * @param {String} router
 */
Vue.prototype.$oneRouter = function (router) {
    let pagelink = this.$route.fullPath
    if (router != pagelink) this.$router.push(router)
}

/**
 * deDounce => 函数防抖
 * 
 * @param {Function} func 执行的业务
 * @param {Number}   wait  防抖的时间
 */
Vue.prototype.$deDounce = function (func, wait) {
    if (this.$timeout) clearTimeout(this.$timeout);
    this.$timeout = setTimeout(func, wait);
}

/**
 * autButton => 路由按钮权限
 * 
 * @param {String} router
 */
Vue.prototype.$autButton = function (value) {
    let buttonArr = []
    value.forEach(item => {
        if (item.path == this.$route.fullPath) {
            if (item.children.length) {
                item.children.forEach((itek) => {
                    if (this.$route.fullPath == itek.path) {
                        buttonArr = itek.children
                    }
                })
            }
        } else {
            item.children.forEach((iten) => {
                if (this.$route.fullPath == iten.path) {
                    buttonArr = iten.children
                }
            })
        }
    })
    return buttonArr
}

/**
 * DownloadXlsx => 导出xlsx文件
 * 
 * @param {Function} data 导出的JSON
 * @param {Number}   name 导出的文件名
 */
Vue.prototype.$DownloadXlsx = function (data, name) {
    let worksheet = XLSX.utils.json_to_sheet(data);
    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, name + '.xlsx');
}

/**
 * getTime => 获取当前日期以及星期
 * 
 * @param {Boolean}   isfleg  获取年月日还是时分秒也包括
 */
Vue.prototype.$getTime = function (isfleg = true) {
    let now = new Date();
    let weekDay = now.getDay();
    let weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    let weekDayName = weekDays[weekDay]
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let datetime = new Object()
    if (isfleg) {
        let months = month >= 10 ? month : "0" + month
        let days = day >= 10 ? day : "0" + day
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();
        datetime.date = year + "-" + months + "-" + days + " " + hours + ":" + minutes + ":" + seconds
        datetime.week = weekDayName
    } else {
        let months = month >= 10 ? month : "0" + month
        let days = day >= 10 ? day : "0" + day
        datetime.date = year + "-" + months + "-" + days
        datetime.week = weekDayName
    }
    return datetime
}

/**
 * getMonth => 获取当前月份的开始和结束（格式：yyyy-MM-dd）
 */
Vue.prototype.$getstrMonthend = function () {
    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let startyear = firstDay.getFullYear();
    let startmonth = String(firstDay.getMonth() + 1).padStart(2, '0');
    let startday = String(firstDay.getDate()).padStart(2, '0');
    let startDate = `${startyear}-${startmonth}-${startday}`;
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    let lastyear = lastDay.getFullYear();
    let lastmonth = String(lastDay.getMonth() + 1).padStart(2, '0');
    let lastday = String(lastDay.getDate()).padStart(2, '0');
    let endDate = `${lastyear}-${lastmonth}-${lastday}`;
    return {
        startDate,
        endDate
    }
}

/**
 * getYearMonth => 获取当前最近几年的年份
 * 
 * @param {Number}  leng  获取最近几年
 */
Vue.prototype.$getYearMonth = function (leng) {
    const currentYear = new Date().getFullYear();
    const years = [];
    const months = [];
    for (let i = 0; i < leng; i++) {
        years.push(currentYear - i);
    }
    for (let i = 0; i < 12; i++) {
        if ((i + 1) < 10) {
            months.push("0" + (i + 1))
        } else {
            months.push((i + 1) + "")
        }
    }
    return {
        years,
        months
    }
}

/**
 * isEndDateAfterStart => 判断日期传输正确
 * 
 * @param {String}  startDate  开始日期
 * @param {String}  endDate    结束日期
 */
Vue.prototype.$isEndDateAfterStart = function (startDate, endDate, isfleg = true) {
    if(isfleg){
        const start = new Date(startDate + "-" + "01");
        const end = new Date(endDate + "-" + "01");
        return end.getTime() > start.getTime();
    }else{
        const start = new Date(startDate);
        const end = new Date(endDate);
        return end.getTime() > start.getTime();
    } 
}

/**
 * v-focus => 自定获取焦点指令
 */
Vue.directive("focus", {
    inserted: function (el) {
        el.focus()
    }
})

export default Vue